<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay" />
            <h1 class="banner-title">Year over year</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen
            v-if="!loaded"
            message="Loading year-over-year statistics…"
        />
        <section v-else class="max-width-container">
            <article>
                <h2>Trips, Places and Duration</h2>
                <BaseChart name="Trips" :options="tripsLocations" />
                <BaseChart name="Days" :options="days" />
            </article>
            <article>
                <h2>Countries - Total and Newly Visited</h2>
                <BaseChart name="Countries" :options="countries" />
            </article>
            <article>
                <h2>Expense Report</h2>
                <BaseChart name="Total expenses" :options="expensesTotal" />
                <BaseChart name="Expenses / trip" :options="expensesTrip" />
                <BaseChart
                    name="Expenses / travel day"
                    :options="expensesDay"
                />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import BaseChart from "js/components/charts/BaseChart";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server";
import { getSimpleBarChart, getBarChart } from "js/lib/charts";
import { useUserStore } from "js/stores/userStore";

export default {
    components: {
        LoadingScreen,
        BaseChart,
    },
    data() {
        return {
            store: null,
            loaded: false,
            trips: null,
            locations: null,
            nights: null,
            newCountries: null,
            visitedCountries: null,
            expenses: null,
        };
    },
    mounted() {
        this.store = useUserStore();

        fetch("/api/stats/yoy").then((response) => {
            let chart = response.data.charts.yoy;
            let currency = this.store.user.currency ?? "$";

            this.tripsLocations = getBarChart(chart.labels, [
                { label: "Trips", data: chart.lines.trips },
                { label: "Places", data: chart.lines.places },
            ]);

            this.days = getSimpleBarChart(
                "Duration (days)",
                chart.labels,
                chart.lines.days
            );

            this.countries = getBarChart(chart.labels, [
                { label: "Total", data: chart.lines.visited_countries },
                { label: "Newly visited", data: chart.lines.new_countries },
            ]);

            let expenseLabels = [];
            chart.lines.expenses.forEach((entry) => {
                if (parseFloat(entry.y) > 0) {
                    expenseLabels.push(entry.x);
                }
            });
            let expenseOptions = {
                scales: {
                    y: {
                        ticks: {
                            callback: (value) => {
                                if (value === 0) {
                                    return "";
                                }
                                if (value < 1000) {
                                    return currency + value;
                                }
                                return currency + value / 1000.0 + "k";
                            },
                        },
                        beginAtZero: true,
                    },
                },
            };

            this.expensesTotal = getBarChart(
                expenseLabels,
                [{ label: "Total expenses", data: chart.lines.expenses }],
                expenseOptions
            );
            this.expensesDay = getBarChart(
                expenseLabels,
                [
                    {
                        label: "Avg. expenses per day",
                        data: chart.lines.expenses_per_day,
                    },
                ],
                expenseOptions
            );
            this.expensesTrip = getBarChart(
                expenseLabels,
                [
                    {
                        label: "Avg. expenses per trip",
                        data: chart.lines.expenses_per_trip,
                    },
                ],
                expenseOptions
            );

            this.loaded = true;
        });
    },
};
</script>
